/* istanbul ignore file */

const config = {
  apiUrl: process.env.REACT_APP_API_URL,
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
  apiKeySecret: process.env.REACT_APP_SENDGRID_API_KEY,
  /**
   * Whether the ORMS Admin item appears in the side menu.
   *
   * On by default nowhere: the variable has to be set to the string 'true'.
   * That keeps Admin visible on staging for ORMS to try while it stays hidden
   * in production, without the two environments running different code.
   *
   * CRA bakes this at BUILD time, so changing it is a workflow edit and a
   * redeploy, never a code change.
   */
  showAdminMenu: process.env.REACT_APP_SHOW_ADMIN_MENU === 'true',
};

export default config;
